import { OrderDetailsProvider } from '@/pages/orders/_components/order-details/OrderDetailsProvider';

import AlertDialog from '@/components/dashboard/alert-dialog';
import GlobalSpinner from '@/components/organisms/GlobalSpinner';
import { PageProvider } from '@/contexts/table-page';
import { SortProvider } from '@/contexts/table-sort';
import { usePageView } from '@/hooks/use-page-view';
import { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import TabSection from './orders/_components/order-details/TabSection';
import TableSection from './orders/_components/order-details/TableSection';
import { LayoutOrderContainer, LayoutTabSection } from './orders/_layouts/LayoutOrderContainer';

const PAGE_VIEWS = {
  'new-order': 'order_list_new',
  'ready-to-ship': 'order_list_ready',
  shipping: 'order_list_shipping',
  delivered: 'order_list_shipping_done',
  cancel: 'order_list_cancel',
  exchange: 'order_list_exchange',
  return: 'order_list_return',
};

type OrderTabs = keyof typeof PAGE_VIEWS;

const OrderDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const orderTab = searchParams.get('orderTab') as OrderTabs;

  usePageView(PAGE_VIEWS[orderTab]);

  return (
    <OrderDetailsProvider>
      <AlertDialog />
      <OrderDetailsContent />
    </OrderDetailsProvider>
  );
};

export default OrderDetailsPage;

const OrderDetailsContent = () => {
  return (
    <LayoutOrderContainer className="flex-1">
      <LayoutTabSection>
        <TabSection />
      </LayoutTabSection>
      <PageProvider>
        <SortProvider>
          <Suspense fallback={<GlobalSpinner />}>
            <TableSection />
          </Suspense>
        </SortProvider>
      </PageProvider>
    </LayoutOrderContainer>
  );
};
